module.exports = __webpack_public_path__ + "img/customer_sell.9e570ea0.png";